export function addLoadingState(event) {
    if (!isFormValid(event)) return;
    if (isEventHtmlEvent(event)) {
        event.currentTarget.classList.add('loading');
    } else {
        console.error("given event " + event + " is not a valid event");
    }
}

export function setVisibility(element, isVisible) {
    if(!element) return;
    
    if (element instanceof Element) {
        if (isVisible) {
            element.removeAttribute("hidden");
        } else {
            element.setAttribute("hidden", "");
        }
    }
}

export function initOpenDialog(){
    const dialogTriggers = document.querySelectorAll("[data-dialog]");
    dialogTriggers.forEach(trigger => {
        if(trigger instanceof Element) {
            const id = trigger.dataset.sourceId;
            if(id){
                const title = trigger.dataset.dialogTitle;
                const size = trigger.dataset.dialogSize;
                trigger.addEventListener("click", function openDialog(e) {
                    window.dialog.open({elemId: id, title: title, size: size});
                })
            }
        }
    })
}

export function setRequired(elem, isRequired) {
    const formField = elem?.classList?.contains("form-field")
        ? elem
        : elem?.querySelector(".form-field");

    formField?.classList.toggle("is-required", isRequired);
}

export function removeLoadingState(target) {
    const element =
        target instanceof Event && target.currentTarget instanceof HTMLElement
            ? target.currentTarget
            : target instanceof HTMLElement
                ? target
                : null;

    if (!element) {
        console.error("removeLoadingState: argument is neither an Event nor an HTMLElement", target);
        return;
    }
    element.classList.remove('loading');
}

export function initLoadingStateButtons(){
    const loaders = document.querySelectorAll('form button[type="submit"]:has([name="loader"]), a:has([name="loader"])');
       
    loaders.forEach(btn => btn.addEventListener("click", addLoadingState));
}

function isEventHtmlEvent(event) {
    return event instanceof Event && event.currentTarget instanceof HTMLElement;
}

/**
 * Checks if the form related to the given event is valid using jQuery validation plugin.
 * @param event
 * @returns {boolean} true if the form is valid or when there is no form available, false otherwise.
 */
function isFormValid(event) {
    if(event.currentTarget.type !== 'submit') return true;
    const form = event.currentTarget.closest('form');
    // if there is no form, no need to validate so return true
    if (!form) return true;

    const $form = $(form);

    return $form && $form.valid();
}
